export function mapFeatureTenant(TenantData) {

    const featureFlags = [
        {
            accessKey: 'featureAccessVehiclePhotoLogsHeraAi',
            enabledKey: 'featureEnabledVehiclePhotoLogsHeraAi',
            accessName: 'Vehicle Management: Vehicle Photo Logs Hera AI',
            enabledName: 'Vehicle Management: Vehicle Photo Logs Hera AI'
        },
        {
            accessKey: 'featureAccessVehiclePhotoLogReview',
            enabledKey: 'featureEnabledVehiclePhotoLogReview',
            accessName: 'Vehicle Management: Vehicle Photo Log Review',
            enabledName: 'Vehicle Management: Vehicle Photo Log Review',
        },
        {
            accessKey: 'featureAccessInventoryManagement',
            enabledKey: 'featureEnabledInventoryManagement',
            accessName: 'Inventory Management',
            enabledName: 'Inventory Management'
        },
        {
            accessKey: 'featureAccessRosterChecklist',
            enabledKey: 'featureEnabledRosterChecklist',
            accessName: 'Roster Checklist',
            enabledName: 'Roster Checklist'
        },
        {
            accessKey: 'featureAccessWirelessSupportSync',
            enabledKey: 'featureEnabledWirelessSupportSync',
            accessName: 'Wireless Support Sync',
            enabledName: 'Wireless Support Sync'
        },
        {
            accessKey: 'featureAccessCustomEmailSending',
            enabledKey: 'featureEnabledCustomEmailSending',
            accessName: 'Custom Email Sending',
            enabledName: 'Custom Email Sending'
        },
        {
            accessKey: 'featureAccessAssociateApp',
            enabledKey: 'featureEnabledAssociateApp',
            accessName: 'Associate App',
            enabledName: 'Associate App'
        },
        {
            accessKey: 'featureAccessHeraMessenger2',
            enabledKey: 'featureEnabledHeraMessenger2',
            accessName: 'Hera Messenger 2',
            enabledName: 'Hera Messenger 2',
        },
        {
            accessKey: 'featureAccessPhoneAutomation',
            enabledKey: 'featureEnabledPhoneAutomation',
            accessName: 'Phone Automation',
            enabledName: 'Phone Automation',
        },
        {
            accessKey: 'featureAccessFilesManagement',
            enabledKey: 'featureEnabledFilesManagement',
            accessName: 'File Management',
            enabledName: 'File Management',
        },
        {
            accessKey: 'featureAccessFilesSignatureRequest',
            enabledKey: 'featureEnabledFilesSignatureRequest',
            accessName: 'Signature Requests',
            enabledName: 'Signature Requests',
        },
        {
            accessKey: 'featureAccessAmazonChromePlugin',
            enabledKey: 'featureEnabledAmazonChromePlugin',
            accessName: 'Hera Amazon Chrome Plugin',
            enabledName: 'Hera Amazon Chrome Plugin',
        },
        {
            accessKey: 'featureAccessAIChat',
            enabledKey: 'featureEnabledAIChat',
            accessName: 'Hera AI Chat',
            enabledName: 'Hera AI Chat',
        },
        {
            accessKey: 'featureAccessPayrollProvider',
            enabledKey: 'featureEnabledPayrollProvider',
            accessName: 'Payroll Provider',
            enabledName: 'Payroll Provider',
        },
        {
            accessKey: 'featureAccessHierarchicalPermissions',
            enabledKey: 'featureEnabledHierarchicalPermissions',
            accessName: 'Hierarchical Permissions',
            enabledName: 'Hierarchical Permissions',
        },
        {
            accessKey: 'featureAccessSchedulingAndRostering',
            enabledKey: 'featureEnabledSchedulingAndRostering',
            accessName: 'Scheduling & Rostering',
            enabledName: 'Scheduling & Rostering',
        },
    ];

    featureFlags.forEach(({ accessKey, enabledKey, accessName }) => {
        TenantData[accessKey] = TenantData.featureAccess.includes(accessName);
        TenantData[enabledKey] = TenantData.featureEnabled.includes(accessName);
    });

    return TenantData;
}

// Sent on every tenant update: id is the key, and group + updatedAt are needed by the
// api() optimistic-lock timestamp check.
export const TENANT_UPDATE_ALWAYS_KEYS = ['id', 'group', 'updatedAt']

const FEATURE_FLAG_KEY = /^feature(Access|Enabled)[A-Z]/

function isSameValue(a, b) {
    if (a === b) return true
    if (a == null || b == null) return a == null && b == null
    if (typeof a === 'object' || typeof b === 'object') return JSON.stringify(a) === JSON.stringify(b)
    return false
}

/**
 * Keep only the fields of a tenant update input that differ from the tenant as it was loaded.
 * The Amplify resolver turns every input key into one DynamoDB UpdateExpression, which is capped
 * at 4 KB, so sending the whole tenant (~77 keys) fails once enough feature flags exist.
 * Values that changed to null/empty are kept; undefined values are dropped (JSON drops them anyway).
 * Fields the loaded tenant does not have are always sent, since there is nothing to compare them to.
 */
export function pickChangedTenantFields(input, originalData, alwaysKeys = TENANT_UPDATE_ALWAYS_KEYS) {
    if (!originalData) return input
    return Object.keys(input).reduce((changed, key) => {
        const value = input[key]
        if (value === undefined) return changed
        const original = originalData[key]
        let same
        if (alwaysKeys.includes(key) || !(key in originalData)) {
            same = false
        } else if (FEATURE_FLAG_KEY.test(key)) {
            // Compare with the stored value, so a stored null equals an unchanged false, and a row stored
            // as enabled without access (which the page shows as off) is still corrected to false.
            same = value === Boolean(original)
        } else {
            same = isSameValue(value, original)
        }
        if (!same) changed[key] = value
        return changed
    }, {})
}
